export async function onCheckout(uid, priceid) {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "content-type": "application/json",
    accept: "application/json",
    "Cache-Control": "no-cache",
  };

  //api/checkout/users.uid/priceid/submissionID/price
  const response = await fetch(
    `/api/checkout/${uid}/${priceid}`,
    {
      method: "GET",
      headers,
    },
  );

  const result = await response.json();
  console.log(result);

  if (
    result.hasOwnProperty("sessionUrl") &&
    result.hasOwnProperty("sessionId")
  ) {
    return result;
  } else {
    throw Error(JSON.stringify(result));
  }
}
